import { StyledArrow } from './Arrow.styles'

const Arrow: React.FC = (): JSX.Element => {
    return <StyledArrow />
}

export default Arrow
